import ProfilI18n from './Profil.i18n.js';
import{
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters([
        'auth',
        'adresses'
    ]),
  },

  data() {
    return {};
  },

  watch: {},

  methods: {
    ...mapActions([
      'getAdresses',
      'getAuth'
    ]),
  },

  mounted() {
    this.getAuth().then(res =>{
      this.getAdresses(this.auth.Code);
    });
  },

  i18n: ProfilI18n,

};
